import React from "react";

function readinessLabel(application) {
  if (application.readiness === "BLOCKED") return "Deployment blocked";
  if (application.readiness === "DISABLED") return "Disabled";
  if (application.readiness === "NOT_READY") return "Not ready";
  return "Unknown";
}

function applicationStatusLabel(status) {
  const labels = {
    RESPONDING: "Application responds; user acceptance not verified",
    NOT_INSTALLED: "Not installed",
    MAINTENANCE: "Maintenance mode",
    UPGRADE_REQUIRED: "Database upgrade required",
    UNAVAILABLE: "Application unavailable",
    NOT_STARTED: "Not started",
    DISABLED: "Disabled",
    UNKNOWN: "Status unknown",
  };
  return labels[status] || "Status unknown";
}

export default function StudioApplications({ applications = [], loading = false, error = "", stale = false }) {
  return (
    <section id="studio-applications" className="studio-applications" aria-labelledby="studio-applications-title">
      <div className="studio-applications-heading">
        <div>
          <div className="studio-section-kicker">STUDIO APPLICATIONS</div>
          <h2 id="studio-applications-title">Your studio tools</h2>
        </div>
        <span className="studio-muted">Application readiness is reported by HACaMS.</span>
      </div>
      {loading && <p role="status" className="studio-muted">Checking configured applications…</p>}
      {error && <p role="status" className="studio-applications-error">{error}</p>}
      {stale && !loading && <p role="status" className="studio-applications-error">Application directory is stale; access links and readiness claims are disabled until a refresh succeeds.</p>}
      {!loading && !stale && (
        <div className="studio-application-grid">
          {applications.map((application) => (
            <article className="studio-application-card" key={application.id}>
              <div className="studio-application-card-heading">
                <div>
                  <h3>{application.name}</h3>
                  <p>{application.purpose}</p>
                </div>
                <span className={`studio-application-status studio-application-status-${String(application.readiness).toLowerCase()}`}>
                  {readinessLabel(application)}
                </span>
              </div>
              <p className="studio-application-probe">{applicationStatusLabel(application.application_status)}</p>
              <p className="studio-application-reason">{application.readiness_reason}</p>
              <div className="studio-application-route">
                <span className="studio-muted">Intended HTTPS route</span>
                {application.entitled === true && application.enabled === true && application.open_url ? (
                  <a href={application.open_url} target="_blank" rel="noopener noreferrer">
                    {application.intended_url}
                  </a>
                ) : (
                  <span>{!application.enabled ? "Disabled" : !application.entitled ? "Not authorized" : application.intended_url || "Not configured"}</span>
                )}
                <span className="studio-muted">
                  {application.tls_status === "ACME_CONFIGURED_UNVERIFIED"
                    ? "ACME route configured; DNS and certificate are unverified."
                    : application.tls_status === "INTERNAL_CA_UNVERIFIED"
                      ? "Internal TLS configured; certificate trust is unverified."
                      : "HTTPS ingress route is not configured."}
                </span>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
